import React from 'react';
import { Box } from '@mui/material';
import UploadDetailsGrid from './UploadDetailsGrid';

const UploadDetails = (): JSX.Element => {
  return (
    <Box>
      <UploadDetailsGrid />
    </Box>
  );
};

export default UploadDetails;
